import { post } from '../api.js';
import { navigate } from '../router.js';
import { currentParams } from '../router.js';
import { lucideIcons, esc } from '../app.js';
import { setToken, getGrantAcceptId, getGrantAcceptSecret, setGrantAcceptId, setGrantAcceptSecret, clearGrantAcceptLocal, getDropClaimId, getDropClaimKey, setDropClaim, setPostAuthRedirect, getPostAuthRedirect } from '../auth-store.js';

export async function renderMagicLink(container) {
  const { params } = currentParams();
  const token = params.get('token');

  if (!token) {
    container.innerHTML = '<div class="login-card"><div class="msg msg-error">Missing magic link token</div></div>';
    return;
  }

  container.innerHTML = '<div class="login-card"><div class="logo"><svg viewBox="0 0 32 32" width="48" height="48"><defs><linearGradient id="bk-magic" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#3ecfb4"/><stop offset="100%" stop-color="#2a9d8f"/></linearGradient></defs><rect width="32" height="32" rx="7" fill="url(#bk-magic)"/><rect x="10" y="14" width="12" height="10" rx="2" fill="#0c0e14"/><path d="M12.5 14V11a3.5 3.5 0 0 1 7 0v3" fill="none" stroke="#0c0e14" stroke-width="2.2" stroke-linecap="round"/><circle cx="16" cy="19" r="1.5" fill="url(#bk-magic)"/><line x1="16" y1="20.5" x2="16" y2="22" stroke="url(#bk-magic)" stroke-width="1.5" stroke-linecap="round"/></svg><div class="brand">Blind<span>Keep</span></div></div><p class="loading" style="text-align:center">Verifying magic link...</p></div>';
  lucideIcons();

  try {
    const result = await post('/auth/magic-link/verify', { token });
    setToken(result.token);

    const grantId = getGrantAcceptId();
    const grantSecret = getGrantAcceptSecret();
    if (grantId && grantSecret) {
      setPostAuthRedirect(`#/grant-accept/${grantId}/${grantSecret}`);
      // Ensure data is in sessionStorage for this tab
      setGrantAcceptId(grantId);
      setGrantAcceptSecret(grantSecret);
      // Clear localStorage copies
      clearGrantAcceptLocal();
    }
    // Check both sessionStorage and localStorage (email link may open in new tab)
    const dropId = getDropClaimId();
    const dropKey = getDropClaimKey();
    if (dropId && dropKey) {
      const redirect = `#/drop/${dropId}/claim?key=${encodeURIComponent(dropKey)}`;
      setPostAuthRedirect(redirect);
      // Copy to sessionStorage for this tab
      setDropClaim(dropId, dropKey);
    }
    // Also check localStorage for post_auth_redirect (set by drop claim page).
    // getPostAuthRedirect() checks both session and local storage; ensure the
    // value is promoted to sessionStorage for downstream consumers.
    const existingRedirect = getPostAuthRedirect();
    if (existingRedirect) {
      setPostAuthRedirect(existingRedirect);
    }

    if (result.needs_password_setup) {
      // Brand-new passwordless user: must set a password before using the
      // vault at all. The server still issues a Full JWT here so the setup
      // endpoints are reachable.
      navigate('#/setup-credential');
    } else if (existingRedirect) {
      // Deep-link destination (grant accept / drop claim / etc.) requires
      // vault keys. Funnel through /unlock so the user enters their
      // password and lands on the target page.
      navigate('#/unlock');
    } else {
      // Default: Limited-session landing. User can stay here (account
      // admin, recovery, close) or click "Unlock vault" to upgrade to a
      // Full session.
      navigate('#/account');
    }
  } catch (err) {
    container.innerHTML = `
      <div class="login-card">
        <div class="logo"><svg viewBox="0 0 32 32" width="48" height="48"><defs><linearGradient id="bk-magic" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#3ecfb4"/><stop offset="100%" stop-color="#2a9d8f"/></linearGradient></defs><rect width="32" height="32" rx="7" fill="url(#bk-magic)"/><rect x="10" y="14" width="12" height="10" rx="2" fill="#0c0e14"/><path d="M12.5 14V11a3.5 3.5 0 0 1 7 0v3" fill="none" stroke="#0c0e14" stroke-width="2.2" stroke-linecap="round"/><circle cx="16" cy="19" r="1.5" fill="url(#bk-magic)"/><line x1="16" y1="20.5" x2="16" y2="22" stroke="url(#bk-magic)" stroke-width="1.5" stroke-linecap="round"/></svg><div class="brand">Blind<span>Keep</span></div></div>
        <div class="msg msg-error">${esc(err.message)}</div>
        <p style="margin-top:1rem;text-align:center"><a href="#/login">Back to login</a></p>
      </div>`;
    lucideIcons();
  }
}
